/**
 * 页面级 UI 初始化
 */

export function initPageScrollbar() {
  const scrollbarEl = document.getElementById('pageScrollbar');
  const thumbEl = document.getElementById('pageScrollbarThumb');
  if (!scrollbarEl || !thumbEl) return;

  const shouldHideCustomScrollbar = () => {
    const hasCoarsePointer = window.matchMedia('(pointer: coarse), (any-pointer: coarse)').matches;
    const isTabletOrMobileViewport = window.matchMedia('(max-width: 1024px)').matches;
    return hasCoarsePointer || isTabletOrMobileViewport;
  };

  const update = () => {
    if (shouldHideCustomScrollbar()) {
      scrollbarEl.style.display = 'none';
      return;
    }

    const doc = document.documentElement;
    const maxScroll = doc.scrollHeight - doc.clientHeight;

    if (maxScroll <= 0) {
      scrollbarEl.style.display = 'none';
      return;
    }

    scrollbarEl.style.display = 'block';

    const trackHeight = window.innerHeight;
    const thumbHeight = trackHeight / 3;
    thumbEl.style.height = `${thumbHeight}px`;

    const scrollTop = doc.scrollTop || 0;
    const top = (scrollTop / maxScroll) * (trackHeight - thumbHeight);
    thumbEl.style.transform = `translateY(${top}px)`;
  };

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
}

export function setupWindowControlsOverlay(syncThemeColor) {
  const wco = navigator.windowControlsOverlay;
  if (!wco) return;

  const update = () => {
    document.body.classList.toggle('wco', !!wco.visible);
    syncThemeColor();
  };

  update();
  wco.addEventListener('geometrychange', update);
}
